import {onFind} from "@elements/init-modules-in-scope";
import {on, find, findIn, removeAttribute, setAttribute} from "@elements/dom-utils";

export function init () {
    onFind('.js-postal-mapping', function (container) {
        let postalInput = findIn('.js-postal-mapping__code', container),
            targetContainer = findIn('.js-postal-mapping__region', container),
            mapping = container.getAttribute('data-postal-code-mapping');


        let countrySelect = findIn('.js-postal-mapping__country', container);
        if (countrySelect && targetContainer) {
            if (countrySelect.value === 'RO') {
                removeAttribute('hidden', targetContainer)
            } else {
                setAttribute('hidden', true, targetContainer)
            }

            on('change', (evt) => {
                if (countrySelect.value === 'RO') {
                    removeAttribute('hidden', targetContainer)
                } else {
                    setAttribute('hidden', true, targetContainer)
                }
            }, countrySelect);
        }

        if (window[mapping] && targetContainer) {
            on('input', (evt) => {
                if (postalInput.value?.length > 1) {
                    let code = postalInput.value.slice(0, 2);
                    let regionMapping = window[mapping][code];

                    findIn('input', targetContainer).value = regionMapping ? regionMapping.region : '';

                }

            }, postalInput);
        }
    });
}